<template>
  <div class="mt-3 text-left w-100">
    <div  id="allmap"></div>
  </div>
</template>

<script>
  export default {
    name: 'Surrounding',
    props:['mapLocation'],
    mounted() {
      this.initMap();
    },
    watch: {
      mapLocation: {
        handler() {
          this.initMap();
        },
        deep: true
      }
    },
    methods: {
      initMap() {
        // 百度地图API功能
        var map = new BMap.Map('allmap');            // 创建Map实例
        let point = new BMap.Point(this.mapLocation.longitude, this.mapLocation.latitude);
        map.addControl(new BMap.ScaleControl());
        map.addControl(new BMap.NavigationControl({
          anchor:BMAP_ANCHOR_TOP_RIGHT
        }));   //平移缩放控件
        map.centerAndZoom(point,15);  //初始化时，即可设置中心点和地图缩放级别
        map.enableScrollWheelZoom(true);  
        let marker = new BMap.Marker(point);
        map.addOverlay(marker);
        let displayTitle = this.mapLocation.title || '';
        var label = new BMap.Label(displayTitle, {offset: new BMap.Size(20, -10)});
        marker.setLabel(label);
        map.enableDoubleClickZoom(true);
      },
    },
  }
</script>
<style>
  #allmap {
    width: 100%;
    height: 500px;
    overflow: hidden;
    margin: 0;
    font-family: "微软雅黑";
  }
  #smallmap{
    width: 100%;
    height: 300px;
  }
</style>
